<template>
  <p class="font-weight-bold pl-4 display-2 female-perc-colour">
    {{ parsedChartData }}%
  </p>
</template>

<script>
export default {
  name: 'FemalePercentageSingleValue',
  props: [
    'chartData'
  ],

  data() {
    return {
    }
  },
  computed: {
    parsedChartData() {
      let perc = null;

      if (this.chartData) {
        this.chartData.forEach((e) => {
          if (e.gender == 'female') {
            perc = e.footfall_percentage
          }
        });
      }

      return Math.round(perc)
    },
  }
}
</script>

<style scoped>
.female-perc-colour {
  color: #ff4df0;
}
</style>
